
import type { PropOptions } from 'vue';
import Vue from 'vue';
import CheckIcon from '~/assets/svg/u_check-circle.vue.svg';
import GmailIcon from '~/components/partials/public-portfolio/assets/gmail-logo.vue.svg';
import BravadoText from '~/components/common/BravadoText/BravadoText.vue';
import ImportContactsButton from '~/components/partials/public-portfolio/PublicPortfolioConnections/ImportContactsButton.vue';
import BravadoSpinnerV2 from '~/components/common/BravadoSpinnerV2/BravadoSpinnerV2.vue';

export default Vue.extend({
  name: 'PublicPortfolioImportContacts',
  components: { ImportContactsButton, BravadoText, GmailIcon, CheckIcon, BravadoSpinnerV2 },
  props: {
    googleRedirectUrl: {
      type: String,
      required: true,
    } as PropOptions<string>,
    hasContacts: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,
    contactsSynced: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,
  },
});
